import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";

import AlbumListComponent from "./AlbumListComponent";
import DeleteConfirm from "Common/Confirm/DeleteConfirm";
import { setOpenDeleteAlbum, setAlbum } from "Actions";
import { deleteAlbum } from "Thunks";
import _ from "i18n";

export class AlbumList extends Component {
  handleDeleteAlbum = () => {
    const { currentAlbum, deleteAlbum, setOpenDeleteAlbum } = this.props;
    deleteAlbum(currentAlbum.id)
      .then(resp => {
        setOpenDeleteAlbum(false);
        toast.success(_("Album deleted successfully"));
        return resp;
      })
      .catch(e => {
        setOpenDeleteAlbum(false);
        toast.error(_("Could not delete the album"));
      });
  };

  cancelDeleteAlbum = () => {
    const { setOpenDeleteAlbum, setAlbum } = this.props;
    setAlbum(null);
    setOpenDeleteAlbum(false);
  };

  renderDeleteModal() {
    const { openDeleteAlbum, deleting } = this.props;

    return (
      <DeleteConfirm
        isOpen={openDeleteAlbum}
        onCancel={this.cancelDeleteAlbum}
        onConfirm={this.handleDeleteAlbum}
        deleting={deleting}
        text={_("Are you sure you want to delete the album ?")}
      />
    );
  }

  render() {
    return (
      <div>
        <AlbumListComponent {...this.props} />
        {this.renderDeleteModal()}
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  currentAlbum: state.albums.currentAlbum,
  deleting: state.albums.deleting,
  openDeleteAlbum: state.albums.openDeleteAlbum
});

const mapDispatchToProps = dispatch => ({
  setOpenDeleteAlbum: visible => dispatch(setOpenDeleteAlbum(visible)),
  setAlbum: album => dispatch(setAlbum(album)),
  deleteAlbum: id => dispatch(deleteAlbum(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumList);



// WEBPACK FOOTER //
// ./src/components/Common/AlbumList/index.js